import { DataSecurityLevel, EVENT_CATEGORY, FIELD_NAME_SEPARATOR, IS_INTENTIONAL, PAGE_APP_NAME, PAGE_NAME, PAGE_TYPE, PAGE_VIEW_DETAILS, } from '@office-start/telemetry-types';
import { convertRouteToPage, getFlattenedFieldName, getPageAppName, getPageType, } from '@office-start/telemetry-utility';
import { getCurrentRouteItem, isRouteInitialized, logEvent, } from '../TelemetryService';
/**
 * Logs PageView event with given properties.
 * - set PageName either currentRoute is available or pageName is given
 *
 * @param properties Properties pertaining to page view event
 *
 */
export function logPageView(properties, securityThreshold) {
    if (securityThreshold === void 0) { securityThreshold = DataSecurityLevel.Security; }
    var params = {};
    params[EVENT_CATEGORY] = "PageView" /* PageView */;
    var eventName;
    if (isRouteInitialized() || properties.pageName) {
        params = setPageDetails(params, properties.pageName);
        // PageView.<PageName>
        eventName = createEventName(getPageName(params));
    }
    params[getFlattenedFieldName([PAGE_VIEW_DETAILS, IS_INTENTIONAL])] =
        properties.isIntentional;
    logEvent(eventName, params, securityThreshold);
}
export function isPageViewEvent(params) {
    return params[EVENT_CATEGORY] === "PageView" /* PageView */;
}
export function setPageDetails(params, page) {
    if (params[getFlattenedFieldName([PAGE_VIEW_DETAILS, PAGE_NAME])]) {
        return params;
    }
    var pageName = page ? page : convertRouteToPage(getCurrentRouteItem());
    params[getFlattenedFieldName([PAGE_VIEW_DETAILS, PAGE_NAME])] = pageName;
    params[getFlattenedFieldName([PAGE_VIEW_DETAILS, PAGE_TYPE])] = getPageType(pageName);
    params[getFlattenedFieldName([PAGE_VIEW_DETAILS, PAGE_APP_NAME])] = getPageAppName(pageName);
    return params;
}
export function createEventName(page) {
    return ['PageView', page].join(FIELD_NAME_SEPARATOR);
}
export function getPageName(params) {
    return params[getFlattenedFieldName([PAGE_VIEW_DETAILS, PAGE_NAME])];
}
//# sourceMappingURL=logPageView.js.map